__turbopack_context__.v({
  "className": "sharpgrotesk15font_bc8585a8-module__fliQjW__className",
  "variable": "sharpgrotesk15font_bc8585a8-module__fliQjW__variable",
});
